<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">All Categories</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">All Categories</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <div class="container">
            <div class="row align-items-center pt-65 pb-20">
                <div class="col-md-4">
                    <div class="product-grid-tab d-flex">
                        <span>{{categories.length}} categories </span>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="product-grid-select float-left float-md-right">
                        <ul>
                            <li>
                                <form class="form-inline" @submit.prevent="searchCategories">
                                    <div class="form-group mx-sm-3 mb-2">
                                        <input v-model="form.search" type="text" class="form-control"
                                               placeholder="Search Categories">
                                    </div>
                                    <button type="submit" class="btn btn-primary mb-2"><i class="fas fa-search"></i>
                                    </button>
                                </form>
                            </li>
                            <small style="color: red" v-if="error && errors.search">{{ errors.search[0] }}</small>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3" v-for="category in pageOfItems" :key="category.id">
                    <div class="sub-product d-flex justify-content-between">
                        <div class="sub-product-item text-center mt-30">
                            <router-link :to="{path: '/categories/' + category.id + '/' + category.name}">
                                <img class="img_cat" v-lazy="category.filePath" :alt="category.name"><br>
                                <span class="cat_title">{{category.name}}</span>
                            </router-link>
                        </div>
                    </div>
                </div> <!-- row -->
            </div>
            <div class="mt-4">
                <p class="text-center">
                    <jw-pagination :items="categories" @changePage="onChangePage" :labels="customLabels"
                                   :pageSize="20"></jw-pagination>
                </p>
            </div>

        </div>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    const customLabels = {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
    };
    export default {
        name: "Categories",
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                error: false,
                errors: {},
                pageOfItems: [],
                customLabels,
                categories: [],
                form: {
                    search: ''
                }
            }
        },
        methods: {
            searchCategories() {
                this.isLoading = true;
                this.axios.post('/search-categories', this.form).then((data) => {
                    this.categories = data.data
                    this.isLoading = false;
                }).catch((resp) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = resp.response.data.errors;
                })
            },
            onChangePage(pageOfItems) {
                this.pageOfItems = pageOfItems;
            },
            getCategories() {
                this.axios.get('/categories').then((data) => {
                    this.categories = data.data
                })
            }
        },
        created() {
            this.getCategories();
        }
    }
</script>

<style scoped>

</style>